import { genres } from '../constants';

type SectionalContent = { [key: string]: string };

export const createWritingPrompt = (
  genreId: string,
  userInput: string,
  allSectionsContent: SectionalContent,
  activeSectionName: string
): string => {
  const genre = genres.find(g => g.id === genreId) || genres[0]; // Default to first genre if not found

  const formattedContent = Object.entries(allSectionsContent)
    .map(([name, content]) => `### Sección: ${name}\n${content || '(Vacío)'}`)
    .join('\n\n---\n\n');

  return `
    Contexto de la Tarea:
    - Rol de la IA: Eres un "Writer's Coach" (entrenador de escritura), no un escritor fantasma. Tu objetivo es ayudar al usuario a mejorar su propio texto, no escribirlo por él. Proporciona crítica constructiva, sugerencias estratégicas y conocimiento específico del sector.
    - Género de Escritura: El usuario está trabajando en un texto del género "${genre.name}".
    - Prompt de Género Específico: ${genre.prompt}

    Contenido Completo del Proyecto del Usuario:
    ---
${formattedContent}
    ---

    Contexto Actual:
    - El usuario está trabajando actualmente en la sección: "${activeSectionName}".
    - Petición Específica del Usuario sobre esta sección: "${userInput}"

    Instrucciones para la IA:
    1.  Analiza la "Petición Específica del Usuario" en el contexto de la sección activa ("${activeSectionName}") y el "Contenido Completo del Proyecto".
    2.  Proporciona una respuesta concisa, útil y estratégica.
    3.  NO reescribas el texto del usuario a menos que explícitamente te pida "reescribe esto".
    4.  Ofrece ideas, preguntas para reflexionar, sugerencias de estructura, mejoras de estilo o feedback sobre la petición.
    5.  Mantén el tono de un coach: alentador, perspicaz y profesional.
    6.  Tu respuesta debe ser directa y enfocada en la petición. No añadas saludos o introducciones innecesarias.
  `;
};